<template>
  <el-dialog
    append-to-body
    width="1200px"
    top="10vh"
    custom-class="team-sales"
    v-loading="fetchLoading"
    element-loading-text="请稍后，全力加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0)"
    :show-close="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="close">
    <div slot="title" class="row align-center space-between team-title">
      <div class="row align-center">
        <i></i>
        <span>历练公单业绩</span>
      </div>
      <i class="el-icon-close" @click="close"></i>
    </div>
    <section class="team-body">
      <el-form size="small" class="team-from" :inline="true" :model="formField">
        <el-form-item label="历练人员">
          <el-input clearable style="width: 140px;" v-model="formField.userName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="业绩分配">
          <el-select v-model="formField.ifAllocation" placeholder="请选择" style="width: 120px;">
            <el-option value="1" label="分配"></el-option>
            <el-option value="0" label="不分配"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单号">
          <el-input clearable style="width: 220px;" v-model="formField.innerSn" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            clearable
            style="width: 300px;"
            v-model="formField.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="searchHandel">查 询</el-button>
        </el-form-item>
      </el-form>
      <div class="team-table">
        <el-table
          border
          ref="table"
          size="small"
          height="65vh"
          :data="tableData"
          :header-cell-style="{
            padding: '5px',
            color: '#333',
            background: '#f0f0f0'
          }"
          :cell-style="{
            color: '#333',
            padding: '5px'
          }"
          :span-method="objectSpanMethod">
          <el-table-column prop="forDate" label="日期"></el-table-column>
          <el-table-column prop="innerSn" label="单号" width="200"></el-table-column>
          <el-table-column prop="temperingUserName" label="历练人员"></el-table-column>
          <el-table-column prop="totalAmount" label="历练公单业绩"></el-table-column>
          <el-table-column prop="ifAllocation" label="业绩分配">
            <template slot-scope="scope">
              {{scope.row.ifAllocation === '1' ? '分配' : '不分配'}}
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="分配姓名"></el-table-column>
          <el-table-column prop="userTotalAmount" label="分配业绩"></el-table-column>
        </el-table>
        <el-pagination
            background
            style="margin-top: 10px;"
            layout="total, sizes, prev, pager, next"
            :current-page="currentPage"
            :page-sizes="[20, 50, 100, 200, 500]"
            :pageSize="pageSize"
            :total="totalItems"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </section>
  </el-dialog>
</template>

<script>
import tool from '@/utils/tool.js'
import newPostUrl from '@/libs/http/modules/oa.js'
export default {
  name: 'TeamSales',
  props: {},
  data() {
    return {
      dialogVisible: true,
      formField: {
        date: '',
        innerSn: '',
        userName: '',
        ifAllocation: ''
      },
      tableData: [],
      fetchLoading: false,
      currentPage: 1,
      pageSize: 50,
      totalItems: 0,
      spanArr: [],
      position: 0,
    }
  },
  created() {
    let tokenTime = tool.data.get('TOKEN_TIME')
    if(tool.data.get('TOKEN') && !this.hasExceededThirtyMinutes(tokenTime)){
      this.fetchData()
    }else{
      //新接口调用需要的新token
      const newRequest = async () => {
        try {
          const result = await newPostUrl.newLogin()
          if (result) {
            this.fetchData()
          }
        } catch (error) {
          this.$message({ type: 'error', message: error.msg || error, duration: 2000, showClose: true })
        }
      }
      newRequest()
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  methods: {
    hasExceededThirtyMinutes(tokenTime) {
      if(!tokenTime){
        return true
      }
      const THIRTY_MINUTES_MS = 30 * 60 * 1000; // 30分钟的毫秒数
      const currentTimestamp = Date.now(); // 当前时间戳
      const timeDifference = currentTimestamp - tokenTime; // 计算时间差
      return timeDifference >= THIRTY_MINUTES_MS; // 判断是否超过30分钟
    },

    close() {
      this.dialogVisible = false
      this.$emit('close')
    },
    resetQuery() {
      for (let key in this.formField) {
        this.formField[key] = ''
      }
      this.currentPage = 1
      this.fetchData()
    },
    searchHandel(){
      this.currentPage = 1
      this.fetchData()
    },
    handleSizeChange(e){
      this.pageSize = e
      this.fetchData()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.fetchData()
    },
    fetchData() {
      this.fetchLoading = true
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        marketingIds: [this.$cache.local.get('marketingUnitId')]
      }
      if (this.formField.userName) {
        params['userName'] = this.formField.userName
      }
      if(this.formField.innerSn){
        params['innerSn'] = this.formField.innerSn
      }
      if (this.formField.ifAllocation) {
        params['ifAllocation'] = this.formField.ifAllocation
      }
      if (this.formField.date && this.formField.date.length) {
        params['startDate'] = this.formField.date[0]
        params['endDate'] = this.formField.date[1]
      }
      newPostUrl.queryPublicOrderPage(params).then(data => {
        this.tableData = data.items || []
        this.totalItems = Number(data.totalItem) || 0
        this.initData(this.tableData)
        this.fetchLoading = false
      }).catch(error => {
        this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
        this.fetchLoading = false
      })
    },

    objectSpanMethod({ rowIndex, columnIndex }) {
      if ([0, 1, 2, 3, 4].includes(columnIndex)) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    initData(list) {
      this.spanArr = []
      this.position = 0
      list.forEach((item, index) => {
        if(index === 0){
          this.spanArr.push(1)
          this.position = 0
        }else{
          if(list[index].innerSn === list[index - 1].innerSn && list[index].totalAmount === list[index - 1].totalAmount){
            this.spanArr[this.position] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.position = index
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.team-sales {
  border-radius: 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.team-title {
  line-height: 50px;
  margin: 0 10px;
  > div {
    i {
      width: 6px;
      height: 24px;
      background: #0b83f3;
      margin-right: 6px;
      border-radius: 2px;
    }
    span {
      font-size: 20px;
    }
  }
  > i {
    font-size: 20px;
    font-weight: bold;
    color: #666;
    cursor: pointer;
  }
}
.team-body {
  background: #fafafa;
  border-radius: 0 0 10px 10px;
  padding-bottom: 15px;
  .team-from {
    padding: 15px 10px 0;
  }
  .team-table {
    padding: 0 10px;
  }
}
</style>
